import { ChatSettingsService } from './chat-settings-service';

export default ChatSettingsService;
